import { z } from 'zod';
export const deliveryEstimate = z.object({
    label: z.string().optional(),
    minDeliveryDate: z.string(),
    maxDeliveryDate: z.string().optional(),
    shippingCutoffDate: z.string().optional(),
});
//# sourceMappingURL=deliveryEstimate.js.map